export const mapStateToProps = ({
  session: { created: sessionCreated, destroyed: sessionDestroyed },
}) => ({
  sessionCreated,
  sessionDestroyed,
})

export const handlers = () => ({})

export const onComponentDidUpdate = (prevProps, props) => {
  const { sessionDestroyed } = props
  if (sessionDestroyed !== prevProps.sessionDestroyed && sessionDestroyed) {
    // It is not necessary to call shutdown intecom because, it will inactivate
    // booting up of intercom for subsequent logins, without reloading
    // props.shutdownIntercom()
  }
}
